"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = default_1;
const bootstrap_1 = require("./bootstrap");
const browser_check_1 = require("./util/browser-check");
/**
 * This functions gets imported by office-server and run there
 */
function default_1() {
    // Window.location.origin is sometimes undefined in IE
    // see https://connect.microsoft.com/IE/feedback/details/1763802/location-origin-is-undefined-in-ie-11-on-windows-10-but-works-on-windows-7
    if (!window.location.origin) {
        window.location.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
    }
    bootstrap_1.IkeOfficeBootstrap.init(window);
    // Check Browser and OS compatibility
    const browserCheck = new browser_check_1.BrowserCheck();
    browserCheck.validateBrowser();
}
//# sourceMappingURL=index.js.map